import { FieldComponentProps, ValidFieldTypes } from '../../../types';
import { validateExpirationDate } from '../../../utils/validate';
import { MaskText } from '../../FormContainer/FormTypes/MaskText';


export const ExpirationDate = ({ isFetching }: FieldComponentProps) => {
  return (
    <MaskText
      {...{
        type: 'text',
        params: {
          name: ValidFieldTypes.EXPIRATION_DATE,
          required: true,
          placeholder: 'MM/YY',
          validate: validateExpirationDate,
          mask: [/\d/, /\d/, '/', /\d/, /\d/],
          disabled: isFetching,
        },
      }}
    />
  );
};
